<template>
    <VueScriptComponent script='<script async src="https://telegram.org/js/telegram-widget.js?11" data-telegram-login="SwisetBot" data-size="medium" data-auth-url="https://app.swiset.com/telegram" data-request-access="write"></script>'/>
</template>

<script>
    import VueScriptComponent from 'vue-script-component';
    export default {
        name: "TelegramSignin",
        components: { VueScriptComponent },
    }
</script>

<style scoped>

</style>
